const getPeriodeEndDate = (startDate = Date.now(), intervall = 6) => {
    let d = new Date(startDate)

    d.setDate(d.getDate() + intervall)
    d.setHours(0)
    d.setMinutes(0)
    d.setSeconds(0)

    return d
} 

export default getPeriodeEndDate